export const STORE_PREFIX = 'LI/PERTAMINA/';
